var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-screen view h-100"},[_c('div',{staticClass:"row bg-extra-light h-100 align-items-center overflow-auto"},[_c('div',{staticClass:"col-12 text-center"},[_c('lottie',{attrs:{"options":_vm.options,"height":400,"width":400},on:{"animCreated":_vm.handleAnimation}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }